import { render } from "./ProfileAccountUpgradeCancelled.vue?vue&type=template&id=653064a0&scoped=true"
import script from "./ProfileAccountUpgradeCancelled.vue?vue&type=script&lang=js"
export * from "./ProfileAccountUpgradeCancelled.vue?vue&type=script&lang=js"

import "./ProfileAccountUpgradeCancelled.vue?vue&type=style&index=0&id=653064a0&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653064a0"]])

export default __exports__